/* eslint-disable no-unused-vars */
import React from 'react';

import Modal from '../..';
import Icon from '@components/icon-component';

import style from './style.module.scss';
import Checkbox from '@components/checkbox';

const AddPSVModal = ({
  open,
  setOpen,

  addNewPSV = false,
  changingPSVVesselRelationship = false,
  addNewPSVEvent,
  linkToExistingPSVsEvent,
  onClickOkEvent,
  isChangingPSVVesselRelationship = false,
  isChangingPSVVesselRelationshipEvent,
  showPSVVesselGrayBox = false
}) => {
  const modalHeaderIcon = React.useMemo(() => {
    if (addNewPSV || changingPSVVesselRelationship) return <Icon name={'add-psv-modal-icon'} />;
  }, [addNewPSV, changingPSVVesselRelationship]);

  const statusText = React.useMemo(() => {
    if (addNewPSV) return <>Add PSV</>;
    else if (changingPSVVesselRelationship) return <>Changing PSV-vessel relationships</>;
  }, [addNewPSV, changingPSVVesselRelationship]);

  const modalTextUpper = React.useMemo(() => {
    if (addNewPSV) return <>Would you like to create a new PSV or link an existing record?</>;
    else if (changingPSVVesselRelationship)
      return (
        <>
          Suggested PSV attachments and detachments are associated with the affected PSV, meaning
          you’ll see it represented by a card in your task list related to the PSV.
        </>
      );
  }, [addNewPSV, changingPSVVesselRelationship]);

  const modalBodyInner = React.useMemo(() => {
    if (addNewPSV)
      return (
        <div>
          <div className={style.modalBtn}>
            <button className="btn-fill button-large modal-btn-height" onClick={addNewPSVEvent}>
              Add new PSV
            </button>
          </div>

          <div className={style.modalBtn}>
            <button
              className={`btn-border button-large modal-btn-height`}
              onClick={linkToExistingPSVsEvent}
            >
              Link existing PSV
            </button>
          </div>
        </div>
      );
    else if (changingPSVVesselRelationship) {
      return (
        <div>
          {showPSVVesselGrayBox && (
            <div className={style.grayBox}>
              <p>
                Since the only change made is to the PSV-vessel relationship, you won’t see a record
                of a vessel change in your task list.
              </p>
            </div>
          )}

          <div className={style.modalBtn}>
            <button className="btn-fill button-large modal-btn-height" onClick={onClickOkEvent}>
              OK
            </button>
          </div>

          {/* {!isChangingPSVVesselRelationship && ( */}
          <>
            <div className={style.divider}></div>

            <div className={style.checkboxContainer}>
              {/* <p>Got it. Don’t tell me again.</p> */}

              <Checkbox
                text={'Got it. Don’t tell me again.'}
                checked={isChangingPSVVesselRelationship}
                handleChange={(e) =>
                  isChangingPSVVesselRelationshipEvent({ value: e?.target?.checked })
                }
                textTransformNone
                labelClassName={style.equipmentBookmarkLabel}
                checkMarkAfter={style.equipmentBookmarkCheckbox}
              />
            </div>
          </>
          {/* )} */}
        </div>
      );
    }
  }, [
    addNewPSV,
    addNewPSVEvent,
    linkToExistingPSVsEvent,
    changingPSVVesselRelationship,
    isChangingPSVVesselRelationshipEvent,
    onClickOkEvent,
    showPSVVesselGrayBox
  ]);

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      icon={modalHeaderIcon}
      statusText={statusText}
      modalTextUpper={modalTextUpper}
      textBtn={changingPSVVesselRelationship ? '' : 'NeverMind'}
    >
      {modalBodyInner}
    </Modal>
  );
};

export default AddPSVModal;
